<template>
    <transition
        @enter="enterTransition"
        @leave="leaveTransition"
        :css="false"
        appear
    >
        <div v-show="isActive" class="tab-pane" v-class="{active: isActive}" :id="name">
            <slot>{{defaultContent}}</slot>
        </div>
    </transition>
</template>
<script>
import Velocity from 'velocity'

export default {
    name: 'oc-tab',
    props: {
        title: {
            type: [String, Number],
            required: true
        },
        id: {
            type: [String, Number],
            default() {
                return this.title.replace(/[^A-Za-z0-9\-]+/g, '-').toLowerCase()
            },
            validator: function (value) {
                return /^[a-z0-9\-]+$/.test(String(value))
            }
        },
        active: {
            type: Boolean,
            default: false
        },
        defaultContent: {
            type: String,
            default: '...'
        },
        linkAttrs: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isActive: false
        }
    },
    mounted() {
        this.isActive = this.active
    },
    computed: {
        name() {
            return this.$parent.name  + '-tab-' + this.id.toLowerCase()
        }
    },
    methods: {
        enterTransition (el, done) {
            if(false === this.$parent.animation) {
                return done()
            }
            Velocity(el, "fadeIn", { duration: 100, easing: this.$parent.animation, complete: done})
        },
        leaveTransition (el, done) {
            if(false === this.$parent.animation) {
                return done()
            }
            Velocity(el, "fadeOut", { delay: 50, duration: 100, easing: this.$parent.animation, complete: done})
        }
    }
}
</script>
